import React, { useState, useEffect } from 'react';
import './ApiDocsViewer.css';

function ApiDocsViewer({ shareId, url, viewer }) {
  const [specUrl, setSpecUrl] = useState(url || null);
  const [loading, setLoading] = useState(!!shareId);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (shareId) {
      const apiBaseUrl = process.env.REACT_APP_API_URL || 'http://localhost:7071';
      const fetchUrl = `${apiBaseUrl}/api/shares/${shareId}/spec`;
      setSpecUrl(fetchUrl);
      setLoading(false);
    }
  }, [shareId]);

  if (loading) {
    return (
      <div className="api-docs-viewer-public">
        <div style={{ padding: '2rem', textAlign: 'center', color: '#666' }}>
          Loading...
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="api-docs-viewer-public">
        <div style={{ padding: '2rem', textAlign: 'center', color: '#d32f2f' }}>
          {error}
        </div>
      </div>
    );
  }

  if (!specUrl) {
    return (
      <div className="api-docs-viewer-public">
        <div style={{ padding: '2rem', textAlign: 'center', color: '#666' }}>
          No spec URL or share ID provided.
        </div>
      </div>
    );
  }

  const v = viewer || 'swagger';
  const src = `/scalar.html?url=${encodeURIComponent(specUrl)}&viewer=${v}`;
  return (
    <div className="api-docs-viewer-public">
      <iframe
        src={src}
        className="api-docs-viewer-scalar"
        title="API Reference"
        sandbox="allow-scripts allow-same-origin allow-popups allow-forms"
      />
    </div>
  );
}

export default ApiDocsViewer;
